const storage: Record<string, string> = {};

const isBrowser = typeof window !== 'undefined' && document.cookie;

const setCookie = (key: string, value: string, expirationTime=30) => {
  if (isBrowser) {
    document.cookie = `${key}=${value}; path=/; max-age=${60 * 60 * 24 * expirationTime}; samesite=lax`;
  } else {
    storage[key] = value;
  }
};

const removeCookie = (key: string) => {
  if (isBrowser) {
    document.cookie = `${key}=; path=/; max-age=0`;
  } else {
    delete storage[key];
  }
};

const getCookie = (key: string) => {
  if (isBrowser) {
    const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
    return match ? match[2] : null;
  } else {
    return storage[key];
  }
};

export default { setCookie, getCookie, removeCookie };
